function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 72 72"
}, props), React.createElement("circle", {
  cx: "35.798",
  cy: "35.798",
  r: "35.798",
  fill: "#fff"
}), React.createElement("path", {
  d: "M59.438 35.58c0-13.136-10.584-23.785-23.637-23.785-13.06.003-23.644 10.649-23.644 23.788 0 11.869 8.646 21.708 19.944 23.493v-16.62h-5.998v-6.873h6.004v-5.244c0-5.96 3.531-9.252 8.93-9.252 2.587 0 5.291.464 5.291.464v5.85h-2.981c-2.934 0-3.85 1.835-3.85 3.718v4.461h6.553l-1.046 6.873h-5.51v16.62c11.299-1.785 19.944-11.624 19.944-23.493z",
  fill: "#59A3BD"
})));